import * as SVG from "svg.js";
import "svg.draggable.js";
import "svg.select.js";
import "svg.resize.js";
import "svg.draw.js"

import "svg.select.js/dist/svg.select.css";

export const unselectize = (element) => {
  element.selectize(false);
};

export const stopDrag = (element) => {
  element.draggable(false);
  element.off('beforedrag');
  element.off('dragmove.namespace');
  element.off('dragend');
};

export const stopResize = (element) => {
  element.resize('stop');
  element.off('resizestart');
  element.off('resizing');
  element.off('resizedone');
};

export const stopDragResize = (node) => {
  if (!node) return;

  const element = SVG.adopt(node);

  unselectize(element);
  
  stopDrag(element);

  stopResize(element);
};

export default SVG;
